import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  response: null,
  error: null,
};

const adminCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_ADMIN_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case ActionTypes.FETCH_ADMIN_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        response: action.payload,
        error: null,
      };

    case ActionTypes.FETCH_ADMIN_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default adminCreateReducer;
